import React from 'react';
import { FadeIn } from './FadeIn';
export function StatsAndTestimonials() {
  return <section className="py-8 bg-surface border-y border-white/5" data-id="element-474">
      <div className="container mx-auto px-4" data-id="element-475">
        <FadeIn data-id="element-476">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-4 divide-x-0 md:divide-x divide-white/10 mb-8" data-id="element-477">
            <div className="flex flex-col items-center text-center px-4" data-id="element-478">
              <span className="text-3xl mb-3" aria-hidden="true" data-id="element-479">
                🏭
              </span>
              <span className="text-2xl font-bold text-white font-heading" data-id="element-480">
                +130
              </span>
              <span className="text-sm text-gray-400 uppercase tracking-wider" data-id="element-481">
                Talleres confían
              </span>
            </div>
            <div className="flex flex-col items-center text-center px-4" data-id="element-482">
              <span className="text-3xl mb-3" aria-hidden="true" data-id="element-483">
                📚
              </span>
              <span className="text-2xl font-bold text-white font-heading" data-id="element-484">
                8
              </span>
              <span className="text-sm text-gray-400 uppercase tracking-wider" data-id="element-485">
                Módulos listos
              </span>
            </div>
            <div className="flex flex-col items-center text-center px-4" data-id="element-486">
              <span className="text-3xl mb-3" aria-hidden="true" data-id="element-487">
                🎁
              </span>
              <span className="text-2xl font-bold text-white font-heading" data-id="element-488">
                3
              </span>
              <span className="text-sm text-gray-400 uppercase tracking-wider" data-id="element-489">
                Bonos incluidos
              </span>
            </div>
            <div className="flex flex-col items-center text-center px-4" data-id="element-490">
              <div className="flex gap-1 mb-3" data-id="element-491">
                {[...Array(5)].map((_, i) => <span key={i} className="text-gold text-lg" data-id="element-492">
                    ★
                  </span>)}
              </div>
              <span className="text-2xl font-bold text-white font-heading" data-id="element-493">
                4.9/5
              </span>
              <span className="text-sm text-gray-400 uppercase tracking-wider" data-id="element-494">
                Calificación
              </span>
            </div>
          </div>
        </FadeIn>

        <div className="grid md:grid-cols-3 gap-6" data-id="element-495">
          <FadeIn delay={0.1} data-id="element-496">
            <div className="bg-background p-6 rounded-2xl border border-white/5 h-full flex flex-col" data-id="element-497">
              <div className="flex gap-1 mb-4" data-id="element-498">
                {[...Array(5)].map((_, i) => <span key={i} className="text-gold text-sm" data-id="element-499">
                    ★
                  </span>)}
              </div>
              <p className="text-gray-300 italic mb-6 flex-grow" data-id="element-500">
                "Armé el primer trabajo con el sistema y no tuve que medir dos
                veces. Las fórmulas de descuento me cambiaron la vida."
              </p>
              <div className="flex items-center gap-3" data-id="element-501">
                <div className="w-10 h-10 rounded-full bg-surfaceLight flex items-center justify-center font-bold text-gold" data-id="element-502">
                  F
                </div>
                <div data-id="element-503">
                  <p className="font-bold text-white text-sm" data-id="element-504">Federico M.</p>
                  <p className="text-xs text-gray-400" data-id="element-505">Mar del Plata</p>
                </div>
              </div>
            </div>
          </FadeIn>

          <FadeIn delay={0.2} data-id="element-506">
            <div className="bg-background p-6 rounded-2xl border border-white/5 h-full flex flex-col" data-id="element-507">
              <div className="flex gap-1 mb-4" data-id="element-508">
                {[...Array(5)].map((_, i) => <span key={i} className="text-gold text-sm" data-id="element-509">
                    ★
                  </span>)}
              </div>
              <p className="text-gray-300 italic mb-6 flex-grow" data-id="element-510">
                "Le pasé las planillas a mi ayudante y trabajó solo toda la
                semana. Por primera vez no tuve que estar encima de todo."
              </p>
              <div className="flex items-center gap-3" data-id="element-511">
                <div className="w-10 h-10 rounded-full bg-surfaceLight flex items-center justify-center font-bold text-gold" data-id="element-512">
                  G
                </div>
                <div data-id="element-513">
                  <p className="font-bold text-white text-sm" data-id="element-514">Gonzalo S.</p>
                  <p className="text-xs text-gray-400" data-id="element-515">
                    Bahía Blanca · Instalador de Mamparas
                  </p>
                </div>
              </div>
            </div>
          </FadeIn>

          <FadeIn delay={0.3} data-id="element-516">
            <div className="bg-background p-6 rounded-2xl border border-white/5 h-full flex flex-col" data-id="element-517">
              <div className="flex gap-1 mb-4" data-id="element-518">
                {[...Array(5)].map((_, i) => <span key={i} className="text-gold text-sm" data-id="element-519">
                    ★
                  </span>)}
              </div>
              <p className="text-gray-300 italic mb-6 flex-grow" data-id="element-520">
                "El Módulo 8 de presupuestos me hizo darme cuenta que estaba
                trabajando sin ganancia real. Ahora cobro lo que corresponde."
              </p>
              <div className="flex items-center gap-3" data-id="element-521">
                <div className="w-10 h-10 rounded-full bg-surfaceLight flex items-center justify-center font-bold text-gold" data-id="element-522">
                  H
                </div>
                <div data-id="element-523">
                  <p className="font-bold text-white text-sm" data-id="element-524">Hernán L.</p>
                  <p className="text-xs text-gray-400" data-id="element-525">San Juan</p>
                </div>
              </div>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}